import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { SendTenantMailCommandHandler } from './send-tenant-mail-command-handler.service';
import { mailCommand } from '../../model/const/command';
import { SendTenantSMSCommandHandler } from './send-tenant-sms-command-handler.service';
import { SendTenantEmailCommandHandler } from './send-tenant-email-command-handler.service';

@Injectable()
export class SendTenantMessageCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    tenantMailHandler: SendTenantMailCommandHandler,
    tenantSMSHandler: SendTenantSMSCommandHandler,
    tenantEmailHandler: SendTenantEmailCommandHandler
  ) {
    super();
    this.addHandler(mailCommand.sendTenantEmail, tenantEmailHandler);
    this.addHandler(mailCommand.sendTenantMail, tenantMailHandler);
    this.addHandler(mailCommand.sendTenantSMS, tenantSMSHandler);
  }
}
